import * as React from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';

import './App.css';
import { Spinner } from './components/common';
import Nav from './components/navigation';
import Routes from './Routes';
import '../node_modules/toastr/build/toastr.min.css';
import withTracker from './withTracker';
import authActions from './auth/authActions';
import questionActions from './common/questionActions';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import axios from 'axios';

interface Props {
	actions: any;
}
interface State {
	isHydrated: boolean;
}
class App extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {
			isHydrated: false
		};
	}
	componentDidMount() {
		axios.defaults.headers.common['Content-Type'] = 'application/json';
		Promise.all([
			this.props.actions.fetchAuthenticatedUser(),
			this.props.actions.getQuestions(),
		])		
		.then(() => this.setState({ isHydrated: true }) );
	}

	render() {
		return !this.state.isHydrated ? (
			<div className="page-content page-content-fullscreen d-flex align-items-center">
				<Spinner className="mx-auto xlarge" />
			</div>
		) : (
			<Router>
				<main>
					<Nav />
					<Route component={withTracker(Routes)} />
				</main>
			</Router>
		);
	}
}

function mapStateToProps(state: any) {
	return {};
}
function mapDispatchToProps(dispatch: any) {
	const actions = { ...authActions, ...questionActions };
	return {
		actions: bindActionCreators(actions, dispatch)
	};
}

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/App.tsx